import React, { useState } from 'react';
import styles from './Auth.module.css';
import { ReactComponent as UserIcon } from '../../assets/icons/user-icon.svg';
import { ReactComponent as PasswordKey } from '../../assets/icons/password-key.svg';
import { authService, LoginInput } from '../../services/auth.service';
import { useNavigate } from 'react-router-dom';
import EyeOpenIcon from '../../assets/icons/EyeIcon';
import EyeClosedIcon from '../../assets/icons/EyeClosedIcon';
import flow888Image from '../../assets/images/flow888.png';
import light from '../../assets/images/light.webp';
import welcome from '../../assets/images/welcomeText.webp';
import welcomeNova from '../../assets/images/welcomeTextNova.png';
import { getErrorMessage } from '../../utils/helpers/getErrorMessage';
import { getCurrentUserBalance } from '../../services/getCurrentUserBalance.service';
import BrandLogo from '../BrandLogo/BrandLogo';
import { getDomainBrand } from '../../utils/getDomainBrand';
import bgFlow888 from '../../assets/images/background-2.webp';
import bgNova7 from '../../assets/images/novaBg.png';
import bgGG888 from '../../assets/images/ggbg.png';
import bgCracker from '../../assets/images/crackerbg.png';

const BRAND_BACKGROUNDS: Record<string, string> = {
  flow888: bgFlow888,
  nova7: bgNova7,
  gg888: bgGG888,
  crackerjackpot: bgCracker,
};

const Auth: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const brand = getDomainBrand();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setIsLoading(true);
    try {
      const result = await authService.login({ username, password });

      // Fetch and update balance after login
      try {
        const balance = await getCurrentUserBalance();
        const updatedUser = { ...result.user, Balance: balance };
        authService.setCurrentUser(updatedUser);
      } catch (balanceError) {
        // Optionally handle balance fetch error, but proceed
        console.error('Failed to fetch balance after login:', balanceError);
      }

      // Note: Roles are automatically fetched during login in authService
      setSuccess('Login successful!');
      setTimeout(() => {
        navigate('/home');
      }, 1000);
    } catch (err: any) {
      setError(getErrorMessage(err));
    } finally {
      setIsLoading(false);
    }
  };

  const handleForgotPassword = () => {
    // Handle forgot password logic here
  };

  return (
    <div className={styles.container} style={{ '--brand-bg': `url(${BRAND_BACKGROUNDS[brand]})` } as React.CSSProperties}>
      <div className={styles.authCard}>
        <div className={styles.header}>
          {/* <h1 className={styles.title}>Welcome to</h1> */}
          <img src={brand === 'nova7' ? welcomeNova : welcome} alt="Flow888" className={styles.welcomeText} />

          <div className={styles.lightContainer}>
            <img src={light} alt="Logo" className={styles.light} />
            <BrandLogo className={styles.flowImage} />
            <img src={light} alt="Logo" className={styles.lightLeft} />
          </div>
          {/* <img src={logoGif} alt="Flow888" className={styles.flowImage} /> */}

        </div>

        <form className={styles.form} onSubmit={handleLogin}>
          {error && <div className={styles.errorMessage}>{error}</div>}
          {success && <div className={styles.successMessage}>{success}</div>}

          {/* <div className={styles.inputGroup}>
            <div className={styles.inputWithIcon}>
              <UserIcon className={styles.inputIcon} />

            </div>
          </div> */}
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className={styles.input}
            placeholder="Username"
            required
            disabled={isLoading}
          />

          {/* <div className={styles.inputGroup}> */}
          <div className={styles.inputWithIcon}>
            {/* <PasswordKey className={styles.inputIcon} /> */}
            <input
              type={showPassword ? 'text' : 'password'}
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={styles.input}
              placeholder="Password"
              required
              disabled={isLoading}
            />
            <button
              type="button"
              className={styles.eyeButton}
              onClick={() => setShowPassword((prev) => !prev)}
              tabIndex={-1}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
              style={{
                background: 'none',
                border: 'none',
                position: 'absolute',
                right: 10,
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                padding: 0,
              }}
            >
              {showPassword ? (
                <EyeOpenIcon style={{ opacity: 0.7 }} />
              ) : (
                <EyeClosedIcon style={{ opacity: 1 }} />
              )}
            </button>
          </div>
          {/* </div> */}

          <div className={styles.forgotPassword}>
            <button
              type="button"
              onClick={handleForgotPassword}
              className={styles.forgotPasswordLink}
              disabled={isLoading}
            >
              Forgot Password?
            </button>
          </div>

          <button
            type="submit"
            className={styles.loginButton}
            disabled={isLoading}
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Auth;
